import React from "react";
import PropTypes from "prop-types";

import {
  TablePagination,
  useTheme,
  IconButton,
  KeyboardArrowRight,
  KeyboardArrowLeft,
  Box,
} from "../helper";

const useStyles = () => ({
  selectBox: () => ({ flexShrink: 0, ml: 2.5 }),
});

function TablePaginationActions({ onPageChange }) {
  const theme = useTheme();
  const style = useStyles();

  const handleBackButtonClick = () => {
    onPageChange(false);
  };

  const handleNextButtonClick = () => {
    onPageChange(true);
  };

  return (
    <Box sx={style.selectBox}>
      <IconButton onClick={handleBackButtonClick} aria-label="previous page">
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton onClick={handleNextButtonClick} aria-label="next page">
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function ChallanTablePagination({ span, populateData, pageNo }) {
  return (
    <TablePagination
      rowsPerPageOptions={[100 /*{ label: "All", value: -1 }*/]}
      colSpan={span}
      count={-1}
      rowsPerPage={100}
      page={pageNo}
      onPageChange={populateData}
      ActionsComponent={TablePaginationActions}
    />
  );
}
